import { get } from "@/service/Axios";
const state = () => ({
  category: [],
  sosmed: [],
  content: []
})

const mutations = {
  setCategory(state, payload) {
    state.category = payload
  },
  setSosmed(state, payload) {
    state.sosmed = payload
  },
  setContent(state, payload) {
    state.content = payload
  }
}

const actions = {
  async getCategory ({ commit }) {
    const { data } = await get(`category/list`, {
      params: {
        status: 'publish'
      }
    })
    commit('setCategory', data.data)
    return data
  },
  async getSosmed ({ commit }) {
    const { data } = await get(`sosmed/list`, {
      params: {
        status: 'publish'
      }
    })
    commit('setSosmed', data.data)
    return data
  },
  async getContent ({ commit }) {
    const { data } = await get(`users/content/detail/5fbc759ad9a773001748e5e8`)
    commit('setContent', data.data)
    return data
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
